import React, { useState } from "react";
import { Layout } from "antd";
import { SiderLogo } from "./siderLogo";
import { SiderMenu } from "./siderMenu";


const MainSider = () => {
  const [collapsed, setCollapsed] = useState(false);

  const { Sider } = Layout;

  const onCollapse = (value: boolean) => {
    setCollapsed(value);
  };

  return (
    <Sider
      theme="light"
      className="bg-slate-300/50"
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="md"
      style={{
        height: "100vh"
      }}
    >
        <SiderLogo collapsed={collapsed} />
        <SiderMenu />
    </Sider>
  );
};

export default MainSider; 
